/** @format */

export default {
	SET_SETTINGS: 'SET_SETTINGS',
	SET_SETTINGS_VALUES: 'SET_SETTINGS_VALUES',
	SET_IS_SAVING_SETTINGS: 'SET_IS_SAVING_SETTINGS',
	SET_SELECTED_PAYMENT_METHOD: 'SET_SELECTED_PAYMENT_METHOD',
	SET_UNSELECTED_PAYMENT_METHOD: 'SET_UNSELECTED_PAYMENT_METHOD',
};
